
import { MainModule } from '@/store/modules/main.store';
import { computed, defineComponent } from 'vue'

export default defineComponent({
  setup () {
    enum enumMenu {
      VIEW_TITLE_USER = '客户',
      VIEW_TITLE_USER_GROUP = '客户组',
      VIEW_TITLE_USER_BLACKLIST = '黑名单'
    }
    const menuFilter = computed(() => {
      return title => {
        return enumMenu[title] ?? title
      }
    })
    const menu = computed(() => MainModule.menus)
    return {
      menuFilter,
      menu
    }
  }
})
